import { text } from "@quickpoint.me/shared";

/**
 * Turns the numeric return codes from back/lib/returnCodes.ts into friendly,
 * localized messages. The codes stay the wire contract (a stable, language-
 * agnostic enum — NOT a security layer; the real boundary is the resolver's
 * JWT/owner check). The UI must never show a bare number to the user.
 *
 * Getters are read at call time, so the message follows the current locale.
 */
const messageByCode: Record<string, () => string> = {
	"1": () => text.errors.codeUnauthorized, // UNAUTHORIZED
	"2": () => text.errors.codeStackNotFound, // STACK_NOT_FOUND
	"3": () => text.stacks.storyExists, // STACK_EXISTS
	"4": () => text.errors.codeInvalidName, // INVALID_STACK_NAME
	"5": () => text.errors.codeFileNotFound, // FILE_NOT_FOUND
	"6": () => text.tkns.freeLimitPresentations, // FREE_LIMIT_PRESENTATIONS
	"7": () => text.tkns.freeLimitPublished, // FREE_LIMIT_PUBLISHED
	"8": () => text.tkns.freeLimitStorage, // FREE_LIMIT_STORAGE
	"9": () => text.errors.codeResidencyPlus, // PLUS_REQUIRED_RESIDENCY
};

/** Free-tier walls (6–9) — the moment to surface the Plus/TKNS panel. */
const UPGRADE_CODES = new Set(["6", "7", "8", "9"]);

/** Friendly, localized message for a resolver return code (or a generic
 *  fallback for an unknown/undefined code). */
export function returnCodeMessage(code?: string | null): string {
	return (code ? messageByCode[code]?.() : undefined) ?? text.errors.codeGeneric;
}

/** True when the code means the account hit a free-tier limit. */
export function isUpgradeCode(code?: string | null): boolean {
	return !!code && UPGRADE_CODES.has(code);
}
